import React, { useEffect, useRef, useState } from "react";
import { Container, Label, Tooltip } from "reactstrap";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Link } from "react-router-dom";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import { AiFillCaretDown } from "react-icons/ai";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoArrowForwardOutline } from "react-icons/io5";
import calender_icon from "../../assets/calende-icon.svg";

import "../MyRoutes/myroutes.scss";
import moment from "moment";
import "./wizardStep2.scss";

function WizardStep2({
  nextPage,
  previousPage,
  setWizardData,
  wizardData,
  startPointName,
  setStartPointName,
}) {
  const [showListModal, setShowListModal] = useState(false);
  const [showClearStartingPoint, setShowClearStartingPoint] = useState("none");
  const [showClearDate, setShowClearDate] = useState("none");
  const [nameOfPoint, setnameOfPoint] = useState({
    name: "",
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);
  // const today = new Date();

  const clearStartingPoint = () => {
    setWizardData({
      ...wizardData,
      startingPoint: "",
    });
    setStartPointName(null);
    setShowClearStartingPoint("none");
  };

  const clearStartDate = () => {
    setWizardData({
      ...wizardData,
      routeStartingDate: "",
    });
    setShowClearDate("none");
  };

  const handleStartPoint = () => {
    setShowListModal(true);
    setnameOfPoint({
      name: "startingPoint",
    });
  };
  useEffect(() => {
    if (wizardData?.routeStartingDate === undefined) {
      setShowClearDate("none");
    } else {
      setShowClearDate("block");
    }
  }, [wizardData?.routeStartingDate]);

  useEffect(() => {
    if (wizardData?.startingPoint?.length === 0) {
      setShowClearStartingPoint("none");
    } else {
      setShowClearStartingPoint("block");
    }
  }, [wizardData?.startingPoint]);

  const handleChange = (e) => {
    setWizardData({
      ...wizardData,
      [e?.target?.name]: e?.target?.value,
    });
  };

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  const datepickerRef = useRef(null);
  const handleDateClick = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setFocus();
    }
  };

  return (
    <div className="wizard_step step2">
      <PointsListingModal
        showListModal={showListModal}
        pointName={startPointName}
        setShowListModal={setShowListModal}
        setPointName={setStartPointName}
        setWizardData={setWizardData}
        wizardData={wizardData}
        nameOfPoint={nameOfPoint}
        setShowClearStartingPoint={setShowClearStartingPoint}
      />
      <Container>
        <div className="nt-wizard_step2">
          <div className="nt-wizard_step2_heading">
            <h2>Choose Your Starting Point</h2>
            <p>Select where you want your journey to begin.</p>
          </div>
          <div className="form_field">
            <form className="nt-form_field_step2">
              <div className="nt-form_group">
                <div className="nt-form_lab">
                  <label className="nt-form-city">City or Location:</label>
                  {wizardData?.startingPoint && (
                    <button
                      className="nt-clear-btn"
                      type="button"
                      style={{ display: showClearStartingPoint }}
                      onClick={clearStartingPoint}
                    >
                      clear
                    </button>
                  )}
                </div>
                <div
                  className="nt-form_input nt-start_input"
                  onClick={handleStartPoint}
                >
                  <button
                    type="button"
                    name="startingPoint"
                    id="startingPoint"
                    value={wizardData?.startingPoint}
                    onChange={handleChange}
                    className="nt-add_start_point"
                  >
                    {wizardData?.startingPoint ? (
                      <span className="nt-point_value">
                        {wizardData?.startingPoint}
                      </span>
                    ) : (
                      <span className="nt-point_placeholder">
                        Enter starting location
                      </span>
                    )}
                  </button>

                  <Link className="nt-arrow" to="#">
                    <AiFillCaretDown size={10} />
                  </Link>
                </div>
              </div>

              <div className="nt-form_group">
                <div className="nt-form_lab">
                  <Label className="nt-form-start-date">Preferred date:</Label>
                  {wizardData?.routeStartingDate && (
                    <button
                      className="nt-clear-btn"
                      type="button"
                      onClick={clearStartDate}
                      style={{ display: showClearDate }}
                    >
                      clear
                    </button>
                  )}
                </div>
                <div className="nt-start-date" onClick={handleDateClick}>
                  <DatePicker
                    id="DisabledAutoHideExample"
                    name="routeStartingDate"
                    selected={wizardData?.routeStartingDate}
                    onChange={(e) =>
                      setWizardData({
                        ...wizardData,
                        routeStartingDate: e,
                      })
                    }
                    minDate={new Date()}
                    showDisabledMonthNavigation
                    className="nt-custom_date"
                    dateFormat="dd/MM/yyyy"
                    onChangeRaw={handleDateChangeRaw}
                    placeholderText="dd/mm/yyyy"
                    autoComplete="off"
                    ref={datepickerRef}
                  />
                  <img
                    src={calender_icon}
                    alt="placeholder"
                    // onClick={handleDateClick}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>

              <div className="nt-button">
                <Link
                  to="#"
                  type="button"
                  onClick={previousPage}
                  className="nt-back-button"
                >
                  <MdOutlineKeyboardBackspace size={24} />
                  <span>Back</span>
                </Link>
                <button type="button" onClick={nextPage}>
                  <span>Next</span>
                  <IoArrowForwardOutline />
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* <Row>
          <Col className="bg-light step_section">
            <ul>
              <li>
                You are done with the first step, Now please select the date
                from which you want to start and also from where you wish to
                start your journey.
              </li>
            </ul>
            <div className="form_field">
              <Form>
                <div className="form_group">
                  <div className="form_lab">
                    <Label>Start Point</Label>
                    {wizardData?.startingPoint && (
                      <button
                        className="clear-btn"
                        type="button"
                        style={{ display: showClearStartingPoint }}
                        onClick={clearStartingPoint}
                      >
                        clear
                      </button>
                    )}
                  </div>
                  <div className="form_input start_input">
                    <Button
                      name="startingPoint"
                      id="startingPoint"
                      onClick={handleStartPoint}
                      value={wizardData?.startingPoint}
                      onChange={handleChange}
                      className="add_start_point"
                    >
                      {wizardData?.startingPoint ? (
                        <span className="point_value">
                          {wizardData?.startingPoint}
                        </span>
                      ) : (
                        <span className="point_placeholder">Start Point</span>
                      )}
                    </Button>
                    <Input
                                            type="text"
                                            autoComplete="off"
                                            onClick={handleStartPoint}
                                            name="startingPoint"
                                            id="startingPoint"
                                            value={wizardData?.startingPoint}
                                            onChange={handleChange}
                                            placeholder="Start Point"
                                        />
                    <Link className="arrow" to="#" onClick={handleStartPoint}>
                      <AiFillCaretDown />
                    </Link>
                  </div>
                </div>

                <div className="form_group">
                  <div className="form_lab">
                    <Label>Start Date</Label>
                    {wizardData?.routeStartingDate && (
                      <button
                        className="clear-btn"
                        type="button"
                        onClick={clearStartDate}
                        style={{ display: showClearDate }}
                      >
                        clear
                      </button>
                    )}
                  </div>
                  <DatePicker
                    id="DisabledAutoHideExample"
                    name="routeStartingDate"
                    selected={wizardData?.routeStartingDate}
                    onChange={(e) =>
                      setWizardData({
                        ...wizardData,
                        routeStartingDate: e,
                      })
                    }
                    minDate={new Date()}
                    showDisabledMonthNavigation
                    className="custom_date"
                    dateFormat="dd/MM/yyyy"
                    onChangeRaw={handleDateChangeRaw}
                    placeholderText="Start Date"
                    autoComplete="off"
                  />
                </div>
                <div className="button">
                  <Link to="#" type="button" onClick={previousPage}>
                    <MdOutlineKeyboardBackspace size={24} />
                    Back
                  </Link>
                  <Button type="button" onClick={nextPage}>
                    Next
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row> */}
      </Container>
      {wizardData?.routeStartingDate && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          autohide={false}
          target="DisabledAutoHideExample"
          toggle={toggle}
        >
          {`${moment(wizardData?.routeStartingDate).format("DD/MM/YYYY")}`}
        </Tooltip>
      )}
    </div>
  );
}

export default WizardStep2;
